import Vue from '../externals/vue';
import twoDecimalPlaces from '../utils/twoDecimalPlaces.js';
Vue.filter('twoDecimalPlaces', twoDecimalPlaces);
